(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('queue-scheduled', {
            parent: 'entity',
            url: '/queue-scheduled?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queue_scheduled.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-scheduled/queue-scheduleds.html',
                    controller: 'Queue_scheduledController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queue_scheduled');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('queue-scheduled-detail', {
            parent: 'entity',
            url: '/queue-scheduled/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'doctorclubboApp.queue_scheduled.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/queue-scheduled/queue-scheduled-detail.html',
                    controller: 'Queue_scheduledDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('queue_scheduled');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Queue_scheduled', function($stateParams, Queue_scheduled) {
                    return Queue_scheduled.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'queue-scheduled',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('queue-scheduled-detail.edit', {
            parent: 'queue-scheduled-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-scheduled/queue-scheduled-dialog.html',
                    controller: 'Queue_scheduledDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Queue_scheduled', function(Queue_scheduled) {
                            return Queue_scheduled.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-scheduled.new', {
            parent: 'queue-scheduled',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-scheduled/queue-scheduled-dialog.html',
                    controller: 'Queue_scheduledDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                dt_ins: null,
                                queue_content: null,
                                ext_id: null, 
                                int_id: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('queue-scheduled', null, { reload: 'queue-scheduled' });
                }, function() {
                    $state.go('queue-scheduled');
                });
            }]
        })
        .state('queue-scheduled.edit', {
            parent: 'queue-scheduled',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-scheduled/queue-scheduled-dialog.html',
                    controller: 'Queue_scheduledDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Queue_scheduled', function(Queue_scheduled) {
                            return Queue_scheduled.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-scheduled', null, { reload: 'queue-scheduled' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('queue-scheduled.delete', {
            parent: 'queue-scheduled',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/queue-scheduled/queue-scheduled-delete-dialog.html',
                    controller: 'Queue_scheduledDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Queue_scheduled', function(Queue_scheduled) {
                            return Queue_scheduled.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('queue-scheduled', null, { reload: 'queue-scheduled' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
